import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import DailyReportTable from "../components/DailyReportTable";
import CenterDailyReportStaticTable from '../components/CenterDailyReportStaticTable';

const CenterDailyData = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Center Daily Data' />

        {/* DashBoardLayerEight */}
        {/* <DailyReportTable /> */}
        <CenterDailyReportStaticTable />
      </MasterLayout>
    </>
  );
};

export default CenterDailyData;
